import React from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AdminRolesManagement from '../../../components/siteadmin/AdminRolesManagement';

import s from './AdminRoles.css';

const AdminRoles = (props) => {

  return <AdminRolesManagement
  />;

}

export default compose(withStyles(s))(AdminRoles);

